import { UserService } from './user.service';
import { Provider } from '@angular/core';
import { TenantService } from './tenant.service';
import { MachineService } from './machine.service';
import { GatewayService } from './gateway.service';
import { SpinnerService } from './spinner-service/spinner.service';
import { ErrorMessageService } from './error-message.service';
import { SoftwareService } from './software.service';
import { AuthHelperService } from './auth-helper.service';
import { GridConfigService } from './grid-config.service';
import { DeviceFilesService } from './device-files.service';
import { FileBaseService } from './file-base.service';
import { BugReportService } from './bug-report.service';
import { SupportBundleService } from './support-bundle.service';

export const serviceProviders: Provider[] = [
  TenantService,
  UserService,
  MachineService,
  GatewayService,
  SpinnerService,
  ErrorMessageService,
  SoftwareService,
  AuthHelperService,
  GridConfigService,
  DeviceFilesService,
  FileBaseService,
  BugReportService,
  SupportBundleService,
];
